import { SearchAndCourseFeatureFacade } from '../../../../search_and_add_courses/facades/search_and_courses_feature_facade';
import { IApplicationConfiguration } from '../../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { ITermProgramInfoModel, TermProgramInfoModel } from '../../../term_courses/models/term_program_info_model';
import { ITermSectionTypesDatasource } from '../../../term_courses/datasources/term_section_types_datasource';
import { ITermCoursesDatasource } from '../../../term_courses/datasources/term_courses_datasource';
import { IQuery } from 'core-ts-types';
import { SectionInfoServant } from '../../../sections/servants/section_info_servant';
import { SectionSwapServant } from '../../../../swap/servants/section_swap_servant';
import { CourseDetailsFacade } from '../../../course_details/facades/course_details_facade';

interface IRegistrationModels {
  account: any;
  selectedCourse: any;
  sectionTypeName: string;
}

class RegistrationHeader {
  private termAndProgramInfo: ITermProgramInfoModel;
  private models: IRegistrationModels = {
    account: {},
    selectedCourse: {},
    sectionTypeName: ''
  };

  private isPreferencesModeActive: boolean = false;
  private institutionName: string = '';
  private courseId: number;
  private courseNk: string = '';
  private showBreadCrumbs: boolean = true;
  private termName = '';
  private termId: number = 0;
  private openDetailDialog: boolean = false;
  private isInSwapMode: boolean = false;
  private showRegistrationControls: boolean = false;
  private hideRegistrationControlsOnMobile: boolean = false;
  constructor(
    private $scope: ng.IScope,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private $window: ng.IWindowService,
    private appConfigModel: IApplicationConfiguration,
    private ngTermProgramInfoModel: TermProgramInfoModel,
    private accountModel: any,
    private ngTermSectionTypesDatasource: ITermSectionTypesDatasource,
    private ngTermCoursesDatasource: ITermCoursesDatasource,
    private ngCourseDetailsFacade: CourseDetailsFacade,
    private ngScheduledSectionsQuery: IQuery,
    private ngSectionInfoServant: SectionInfoServant,
    private ngSearchAndCourseFeatureFacade: SearchAndCourseFeatureFacade,
    private ngSectionSwapServant: SectionSwapServant
  ) {}

  $onChanges() {
    this.init();
  }
  $onInit() {
    this.init();
  }
  init() {
    this.termAndProgramInfo = this.ngTermProgramInfoModel.read();
    this.termName = _4.get(this.termAndProgramInfo, 'term.name', '');
    this.isPreferencesModeActive = false;
    this.institutionName = this.appConfigModel.model.member_configs['core-inst_name'];
    this.courseId = this.$stateParams.courseId;
    this.courseNk = this.$stateParams.courseNk;
    this.termId = this.$stateParams.termId;
    this.models = {
      account: this.accountModel,
      selectedCourse: {},
      sectionTypeName: ''
    };
    this.$scope.$watch(
      () => this.$state.params.courseId,
      (nv, ov) => {
        this.updateSelectedCourse();
      }
    );
    this.isInSwapMode = this.ngSectionSwapServant.isInSwapMode();
    this.showRegistrationControls = !this.isInSwapMode;
  }

  openDetail() {
    this.ngCourseDetailsFacade.openCourseDetails(this.courseNk);
  }

  getScheduledCredits() {
    return _4.get(this.ngScheduledSectionsQuery, 'result.creditsScheduled', 0);
  }

  goBackToTermCourses() {
    this.$state.go('my.schedule.registration', {}, { reload: 'my.schedule.registration' });
  }

  updateSelectedCourse() {
    this.courseId = _4.get(this.$state, 'params.courseId');
    this.models.selectedCourse = _4.isUndefined(this.$state.params.courseId)
      ? {}
      : this.ngTermCoursesDatasource.get(parseInt(this.$state.params.courseId, 10));
    this.showBreadCrumbs = !_4.isEmpty(this.models.selectedCourse);
    const sectionTypeId = parseInt(this.$state.params.sectionTypeId, 10);
    const sectionType = this.ngTermSectionTypesDatasource.get(sectionTypeId);
    this.models.sectionTypeName = sectionType ? sectionType.name : '';
  }

  print() {
    this.$window.print();
  }
}

class RegistrationHeaderComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.controller = RegistrationHeader;
    this.bindings = {
      scheduledSections: '<'
    };
    this.templateUrl =
      'capability-ng-scheduler/src/views/registration/components/registration_header/registration_header.html';
  }
}
angular.module('capability-ng-scheduler').component('registrationHeader', new RegistrationHeaderComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_header/registration_header.ts